import axios from 'axios'
import Vue from 'vue';
import { Notify } from 'vant';
import { getToken } from '@/utils/auth.js'
Vue.use(Notify);

//import store from '@/store'

const service = axios.create({
    // baseURL:process.env.BASE_API,
    // baseURL:'http://api.gcszwyc.com',
    timeout: 5000,
    // responseType:'json',
    // withCredentials:true,
    // headers: {
    //    "Content-Type": "application/json;charset=utf-8"
    //"Content-Type": "application/x-www-form-urlencoded"
    // }
})
//请求拦截器
service.interceptors.request.use( 
    config => {
        //在请求之前做加入token
        //console.log('请求拦截器全局',store.getters.token)
        if (getToken()) {
            config.headers['Authorization'] = getToken()
        }
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
	
)

//响应拦截器
service.interceptors.response.use(
    response => {
        let res = response.data
        if (!res.success) {
           Notify(`${res.msg}`);
          console.log(res.msg)
        }
        return response
    },
    //错误处理
    error => {
        console.log('err-------' + error)
        Notify(`${error}`);
        if(error=='Error: timeout of 5000ms exceeded'){
            Notify('超时5000');
        }else{
            Notify(`${error}`);
        }
        return Promise.reject(error);
    }
	
	
)

export default service